import axios from "axios";

export default {
    postData(url, obj) {
        return axios
          .post(url, obj)
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            return error.response;
          });
      },
    
      getData(url, token) {
        return axios
          .get(url, { headers: { Authorization: "Bearer " + token } })
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            return error.response;
          });
      },

      postDataWithToken(url, paramsObj, token) {
        return axios
          .post(url, paramsObj, { headers: { Authorization: "Bearer " + token } })
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            return error.response;
          });
      },
};